import {apiPath} from "@pg-mono/rp-api-routes";
import {createTurnstileRtkError} from "@pg-mono/turnstile";

import {rpApi} from "../../app/api/rp_api";
import {TurnstileAction} from "../../app/constants/turnstile_actions";
import {createRpLeadPerformanceDebugTrace} from "../../app/performance_debug";
import {appendTurnstileToken} from "../../app/turnstile";
import {notifyBugsnag} from "../../errors/bugsnag/notify_bugsnag";
import {IApplicationData} from "../types/IApplicationData";

export const createApplicationApi = rpApi.injectEndpoints({
    endpoints: (build) => ({
        createApplication: build.mutation<IApplicationData, Partial<IApplicationData>>({
            queryFn: async (body, _api, _extraOptions, baseQuery) => {
                const trace = createRpLeadPerformanceDebugTrace("rp_create_application_api", {
                    action: TurnstileAction.APPLICATION_CREATE,
                    endpoint: "applications.create",
                    hasOffer: typeof body.offer === "number",
                    hasProperty: typeof body.property === "number",
                    hasVendor: typeof body.vendor === "number",
                    source: body.source,
                    sourceSection: body.source_section
                });

                try {
                    trace.mark("turnstile_append:start");
                    const payload = await appendTurnstileToken(body, TurnstileAction.APPLICATION_CREATE);
                    trace.mark("turnstile_append:done", {hasTurnstileToken: "turnstile_token" in payload});

                    trace.mark("api_request:start");
                    const result = await baseQuery({
                        url: apiPath.applications.create.base,
                        method: "POST",
                        body: payload
                    });
                    trace.mark("api_request:done", {
                        hasError: Boolean(result.error),
                        status: result.error?.status ?? "success"
                    });

                    if (result.error) {
                        const error = `createApplicationApi error: ${result.error.status}`;
                        notifyBugsnag(error, error);

                        trace.end("query:error", {status: result.error.status});
                        return {error: result.error};
                    }

                    trace.end("query:success");
                    return {data: result.data as IApplicationData};
                } catch (_error) {
                    trace.end("query:turnstile_error");
                    return {error: createTurnstileRtkError()};
                }
            }
        })
    })
});

export const {useCreateApplicationMutation} = createApplicationApi;
import {apiPath} from "@pg-mono/rp-api-routes";
import {createTurnstileRtkError} from "@pg-mono/turnstile";

import {rpApi} from "../../app/api/rp_api";
import {TurnstileAction} from "../../app/constants/turnstile_actions";
import {createRpLeadPerformanceDebugTrace} from "../../app/performance_debug";
import {appendTurnstileToken} from "../../app/turnstile";
import {notifyBugsnag} from "../../errors/bugsnag/notify_bugsnag";
import {IApplicationData} from "../types/IApplicationData";

export const createApplicationApi = rpApi.injectEndpoints({
    endpoints: (build) => ({
        createApplication: build.mutation<IApplicationData, Partial<IApplicationData>>({
            queryFn: async (body, _api, _extraOptions, baseQuery) => {
                const trace = createRpLeadPerformanceDebugTrace("rp_create_application_api", {
                    action: TurnstileAction.APPLICATION_CREATE,
                    endpoint: "applications.create",
                    hasOffer: typeof body.offer === "number",
                    hasProperty: typeof body.property === "number",
                    hasVendor: typeof body.vendor === "number",
                    source: body.source,
                    sourceSection: body.source_section
                });

                try {
                    trace.mark("turnstile_append:start");
                    const payload = await appendTurnstileToken(body, TurnstileAction.APPLICATION_CREATE);
                    trace.mark("turnstile_append:done", {hasTurnstileToken: "turnstile_token" in payload});

                    trace.mark("api_request:start");
                    const result = await baseQuery({
                        url: apiPath.applications.create.base,
                        method: "POST",
                        body: payload
                    });
                    trace.mark("api_request:done", {
                        hasError: Boolean(result.error),
                        status: result.error?.status ?? "success"
                    });

                    if (result.error) {
                        const error = `createApplicationApi error: ${result.error.status}`;
                        notifyBugsnag(error, error);

                        trace.end("query:error", {status: result.error.status});
                        return {error: result.error};
                    }

                    trace.end("query:success");
                    return {data: result.data as IApplicationData};
                } catch (_error) {
                    trace.end("query:turnstile_error");
                    return {error: createTurnstileRtkError()};
                }
            }
        })
    })
});

export const {useCreateApplicationMutation} = createApplicationApi;
